export interface Config {
  APP_ENV: string;
  MAKRO_WEB_APP_URL: string;
  SHOPIFY_API_ENDPOINT: string;
  SHOPIFY_ACCESS_TOKEN: string;
  BACKEND_API_ENDPOINT: string;
  BASKET_API_ENDPOINT: string;
  PRODUCT_API_ENDPOINT: string;
  SEARCH_API_ENDPOINT: string;
  SEARCH_API_ENDPOINT_BASE: string;
  APP_BASE_URL: string;
  ENABLE_3P_OWNFLEET: boolean;
  USER_API_ENDPOINT: string;
  WEB_ALLOW_ALCOHOL: boolean;
  ALCOHOL_HIDE_PRODUCT_PRICE: {
    [key: string]: string | boolean;
  };
  ALCOHOL_PRODUCT_AVAILABILITY: {
    [key: string]: string | boolean;
  };
  ENABLE_SELL_IN_PIECE: boolean;
  ENABLE_1PX: boolean;
  RECOMMENDATION_API_ENDPOINT: string;
  SHOPPING_PDP_REVAMP_ENABLED: boolean;
  ENABLE_PDP_RECOMMENDATION_NEW_UI_FLAG: boolean;
  PRODUCT_REST_API_ENDPOINT_V2: string;
  AUTH_API_ENDPOINT: string;
  API_AUTH_HEADER: string;
  AS_PLP_PROPOINT_PROMOTION_ENABLED: boolean;
  LOYALTY_COMPLEX_PROMOTION_ENABLED: boolean;
  LOYALTY_COMPLEX_PROMOTION_PRIORITY: boolean;
  PLP_PROPOINT_PROMOTION_ENABLED: boolean;
  SHOPPING_CAROUSEL_MAX_ITEM_COUNT_VIEW: string;
  STORE_PICKUP_RECOMMENDATIONS_ENABLED: boolean;
  SHOPPING_ENABLE_ENHANCED_MARKETING_BADGE: boolean;
  SHOPPING_ENABLE_UNIFIED_BASKET: boolean;
  SHOPPING_ENABLE_PRODUCT_CARD_V2_1: boolean;
  ENABLE_STORE_CODES_FOR_RECOMMENDATIONS: boolean;
  ENABLE_RECOMMENDATION_BANNERS: boolean;
  SHOPPING_ENABLE_SECONDARY_PRICING: boolean;
  SAME_DAY_DELIVERY_SERVICE_URL: string;
  ENABLE_REALTIME_DELIVERY_SLOT: {
    [key: string]: string | boolean;
  };
  DELIVERY_DESCRIPTION_FALLBACK_CONFIG: string;
  LOYALTY_RM3_PROMOTION_FROM_PRODUCT_API: boolean;
  SHOPPING_ENABLE_PRODUCT_NEW_TAG: boolean;
  SHOPPING_ENABLE_PRODUCT_OPTION_SELECTOR: boolean;
  SHOPPING_ENABLE_PROGRESS_BAR_ON_PRODUCT_CARD: boolean;
  SHOPPING_PRODUCT_CARD_PROGRESS_BAR_CONFIG: string;
  SHOPPING_ENABLE_PRODUCT_CARD_VIDEO: {
    [key: string]: string | boolean;
  };
  SHOPPING_ENABLE_HORECA: {
    [key: string]: string | boolean;
  };
  SHOPPING_ENABLE_PRODUCT_CARD_VIDEO_MIN_VERSION: {
    [key: string]: string;
  };
  SHOPPING_ENABLE_HORECA_MIN_VERSION: {
    [key: string]: string;
  };
  HORIZON_UI_UX_MIN_VERSION: {
    [key: string]: string;
  };
  TWO_P_MIN_APP_VERSION: {
    [key: string]: string;
  };
  CLUB_MEMBER_PRICE_ENABLED: boolean;
  ENABLE_PRODUCT_SERVICE_OPTIMIZE_QUERY: boolean;
  DELIVERY_DESCRIPTION_FALLBACK_COUNTRY_CONFIG: {
    [key: string]: { enabled: boolean; preferFallback: boolean };
  };
  ENABLE_HORIZON_PRODUCT_CARD: {
    [key: string]: string | boolean;
  };
  LOYALTY_CAMPAIGN_PROMO_TAG_V2_ENABLED: {
    [key: string]: string | boolean;
  };
  ENABLE_DIVERSIFY_RECOMMENDATIONS: {
    [key: string]: string | boolean;
  };
  ENABLE_MULTI_DROP: {
    [key: string]: string | boolean;
  };
  LOCATION_SERVICE_URL: string;
}

export const getAsBoolean = (env: string | undefined): boolean => {
  return JSON.parse(env || 'false');
};

export const getAsJson = (env?: string) => {
  try {
    return JSON.parse(env || '{}');
  } catch {
    return {};
  }
};

const onlyPublicConfig = {
  APP_ENV: process.env.REACT_APP_APP_ENV || 'development',
  SHOPIFY_API_ENDPOINT: process.env.REACT_APP_SHOPIFY_API_ENDPOINT || '',
  BACKEND_API_ENDPOINT: process.env.REACT_APP_BACKEND_API_ENDPOINT || '',
  BASKET_API_ENDPOINT: process.env.REACT_APP_BASKET_API_ENDPOINT || '',
  PRODUCT_API_ENDPOINT: process.env.REACT_APP_PRODUCT_API_ENDPOINT || '',
  APP_BASE_URL: process.env.REACT_APP_BASE_URL || '',
  SEARCH_API_ENDPOINT: process.env.REACT_APP_SEARCH_API_ENDPOINT || '',
  SEARCH_API_ENDPOINT_BASE: process.env.REACT_APP_SEARCH_API_ENDPOINT_BASE || '',
  ENABLE_3P_OWNFLEET: getAsBoolean(process.env.REACT_APP_ENABLE_3P_OWNFLEET) || false,
  USER_API_ENDPOINT: process.env.REACT_APP_USER_API_ENDPOINT || '',
  WEB_ALLOW_ALCOHOL: getAsBoolean(process.env.REACT_APP_WEB_ALLOW_ALCOHOL) || true,
  ALCOHOL_HIDE_PRODUCT_PRICE: getAsJson(process.env.REACT_APP_ALCOHOL_HIDE_PRODUCT_PRICE),
  ALCOHOL_PRODUCT_AVAILABILITY: getAsJson(process.env.REACT_APP_ALCOHOL_PRODUCT_AVAILABILITY),
  ENABLE_SELL_IN_PIECE: getAsBoolean(process.env.REACT_APP_ENABLE_SELL_IN_PIECE) || true,
  ENABLE_1PX: getAsBoolean(process.env.REACT_APP_ENABLE_1PX) || true,
  SHOPPING_PDP_REVAMP_ENABLED: getAsBoolean(process.env.REACT_APP_SHOPPING_PDP_REVAMP_ENABLED) || true,
  RECOMMENDATION_API_ENDPOINT: process.env.REACT_APP_RECOMMENDATION_API_ENDPOINT || '',
  PRODUCT_REST_API_ENDPOINT_V2: process.env.REACT_APP_PRODUCT_REST_API_ENDPOINT_V2 || '',
  SHOPPING_CAROUSEL_MAX_ITEM_COUNT_VIEW: process.env.REACT_APP_SHOPPING_CAROUSEL_MAX_ITEM_COUNT_VIEW || '{}',
  AUTH_API_ENDPOINT: process.env.REACT_APP_AUTH_API_ENDPOINT || '',
  API_AUTH_HEADER: process.env.REACT_APP_API_AUTH_HEADER || '',
  MAKRO_WEB_APP_URL: process.env.REACT_APP_MAKRO_WEB_APP_URL || '',
  AS_PLP_PROPOINT_PROMOTION_ENABLED: getAsBoolean(process.env.REACT_APP_AS_PLP_PROPOINT_PROMOTION_ENABLED) || false,
  LOYALTY_COMPLEX_PROMOTION_ENABLED: getAsBoolean(process.env.REACT_APP_LOYALTY_COMPLEX_PROMOTION_ENABLED) || false,
  LOYALTY_COMPLEX_PROMOTION_PRIORITY: getAsBoolean(process.env.REACT_APP_LOYALTY_COMPLEX_PROMOTION_PRIORITY) || false,
  PLP_PROPOINT_PROMOTION_ENABLED: getAsBoolean(process.env.REACT_APP_PLP_PROPOINT_PROMOTION_ENABLED) || false,
  STORE_PICKUP_RECOMMENDATIONS_ENABLED:
    getAsBoolean(process.env.REACT_APP_STORE_PICKUP_RECOMMENDATIONS_ENABLED) || false,
  SHOPPING_ENABLE_ENHANCED_MARKETING_BADGE:
    getAsBoolean(process.env.REACT_APP_SHOPPING_ENABLE_ENHANCED_MARKETING_BADGE) || false,
  SHOPPING_ENABLE_UNIFIED_BASKET: getAsBoolean(process.env.REACT_APP_SHOPPING_ENABLE_UNIFIED_BASKET) || false,
  SHOPPING_ENABLE_PRODUCT_CARD_V2_1: getAsBoolean(process.env.REACT_APP_SHOPPING_ENABLE_PRODUCT_CARD_V2_1) || false,
  ENABLE_STORE_CODES_FOR_RECOMMENDATIONS:
    getAsBoolean(process.env.REACT_APP_ENABLE_STORE_CODES_FOR_RECOMMENDATIONS) || false,
  ENABLE_RECOMMENDATION_BANNERS: getAsBoolean(process.env.REACT_APP_ENABLE_RECOMMENDATION_BANNERS) || false,
  SHOPPING_ENABLE_SECONDARY_PRICING: getAsBoolean(process.env.REACT_APP_SHOPPING_ENABLE_SECONDARY_PRICING) || false,
  ENABLE_PDP_RECOMMENDATION_NEW_UI_FLAG: getAsBoolean(process.env.REACT_APP_ENABLE_PDP_RECOMMENDATION_NEW_UI) || false,
  DELIVERY_DESCRIPTION_FALLBACK_CONFIG: process.env.REACT_APP_DELIVERY_DESCRIPTION_FALLBACK_CONFIG || '',
  DELIVERY_DESCRIPTION_FALLBACK_COUNTRY_CONFIG: JSON.parse(
    process.env.REACT_APP_DELIVERY_DESCRIPTION_FALLBACK_COUNTRY_CONFIG || '{}',
  ),
  ENABLE_DIVERSIFY_RECOMMENDATIONS: getAsJson(process.env.REACT_APP_ENABLE_DIVERSIFY_RECOMMENDATIONS) || '{}',
  ENABLE_MULTI_DROP: getAsJson(process.env.REACT_APP_ENABLE_MULTI_DROP),
  LOCATION_SERVICE_URL: process.env.REACT_APP_LOCATION_SERVICE_URL || '',
  ENABLE_PRODUCT_SERVICE_OPTIMIZE_QUERY:
    getAsBoolean(process.env.REACT_APP_ENABLE_PRODUCT_SERVICE_OPTIMIZE_QUERY) || false,
  ENABLE_HORIZON_PRODUCT_CARD: getAsJson(process.env.REACT_APP_ENABLE_HORIZON_PRODUCT_CARD),
  SAME_DAY_DELIVERY_SERVICE_URL: process.env.REACT_APP_SAME_DAY_DELIVERY_SERVICE_URL || '',
  ENABLE_REALTIME_DELIVERY_SLOT: getAsJson(process.env.REACT_APP_ENABLE_REALTIME_DELIVERY_SLOT),
  HORIZON_UI_UX_MIN_VERSION: getAsJson(process.env.REACT_APP_HORIZON_UI_UX_MIN_VERSION),
  TWO_P_MIN_APP_VERSION: getAsJson(process.env.REACT_APP_FE_2P_MIN_APP_VERSION),
  CLUB_MEMBER_PRICE_ENABLED: getAsBoolean(process.env.REACT_APP_CLUB_MEMBER_PRICE_ENABLED) || false,
  SHOPPING_ENABLE_PRODUCT_NEW_TAG: getAsBoolean(process.env.REACT_APP_SHOPPING_ENABLE_PRODUCT_NEW_TAG) || false,
  LOYALTY_RM3_PROMOTION_FROM_PRODUCT_API: getAsBoolean(process.env.REACT_APP_LOYALTY_RM3_PROMOTION_FROM_PRODUCT_API),
  SHOPPING_ENABLE_PRODUCT_OPTION_SELECTOR:
    getAsBoolean(process.env.REACT_APP_SHOPPING_ENABLE_PRODUCT_OPTION_SELECTOR) || false,
  SHOPPING_ENABLE_PROGRESS_BAR_ON_PRODUCT_CARD:
    getAsBoolean(process.env.REACT_APP_SHOPPING_ENABLE_PROGRESS_BAR_ON_PRODUCT_CARD) || false,
  SHOPPING_PRODUCT_CARD_PROGRESS_BAR_CONFIG:
    process.env.REACT_APP_SHOPPING_PRODUCT_CARD_PROGRESS_BAR_CONFIG || '',
  SHOPPING_ENABLE_PRODUCT_CARD_VIDEO: getAsJson(process.env.REACT_APP_SHOPPING_ENABLE_PRODUCT_CARD_VIDEO),
  SHOPPING_ENABLE_HORECA: getAsJson(process.env.REACT_APP_FE_SHOPPING_ENABLE_HORECA),
  SHOPPING_ENABLE_PRODUCT_CARD_VIDEO_MIN_VERSION: getAsJson(
    process.env.REACT_APP_FE_SHOPPING_ENABLE_PRODUCT_CARD_VIDEO_MIN_VERSION,
  ),
  SHOPPING_ENABLE_HORECA_MIN_VERSION: getAsJson(process.env.REACT_APP_FE_SHOPPING_ENABLE_HORECA_MIN_VERSION),
  LOYALTY_CAMPAIGN_PROMO_TAG_V2_ENABLED: getAsJson(process.env.REACT_APP_LOYALTY_CAMPAIGN_PROMO_TAG_V2_ENABLED) || '{}',
};

const onlySecretConfig = {
  SHOPIFY_ACCESS_TOKEN: process.env.REACT_APP_SHOPIFY_ACCESS_TOKEN || '',
};

const config: Config = {
  ...onlyPublicConfig,
  ...onlySecretConfig,
};

export { onlyPublicConfig, config };
